import http from './http'

export function listPlans() {
  return http.get('/public/plans', { skipAuthRedirect: true })
}

export function getBillingConfig() {
  return http.get('/billing/config')
}

export function getSubscription() {
  return http.get('/billing/subscription')
}

export function subscribe(planSlug, provider) {
  return http.post('/billing/subscribe', { plan_slug: planSlug, provider })
}

export function verifyPakasirPayment(orderId) {
  return http.post('/billing/pakasir/verify', { order_id: orderId })
}

export function cancelSubscription() {
  return http.post('/billing/cancel')
}

export function listSubscriptions(params = {}) {
  return http.get('/billing/subscriptions', { params })
}

export function getSubscriptionById(id) {
  return http.get(`/billing/subscriptions/${id}`)
}

export function downloadSubscriptionInvoice(id) {
  return http.get(`/billing/subscriptions/${id}/invoice`, { responseType: 'blob' })
}

export function cancelSubscriptionById(id) {
  return http.post(`/billing/subscriptions/${id}/cancel`)
}

export function resumeSubscriptionPayment(id) {
  return http.post(`/billing/subscriptions/${id}/pay`)
}
